module.exports = __webpack_public_path__ + "static/media/players.394b098a.svg";